import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["headline", "answer", "showbutton", "hidebutton"];

  connect() {
    console.log("faq speaking here…");
  }
  toggle(e) {
    e.preventDefault();
    e.stopPropagation();
    this.answerTarget.classList.toggle("d-none");
    this.showbuttonTarget.classList.toggle("d-none");
    this.hidebuttonTarget.classList.toggle("d-none");
  }
}
